var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$apollo.loading)?_c('v-skeleton-loader',{attrs:{"type":"card"}}):(_vm.hasData)?_c('div',[(_vm.weightChart())?_c('highcharts',{attrs:{"options":_vm.weightChart()}}):_vm._e()],1):_c('div',[_c('span',{staticClass:"grey-info--text font-italic"},[_vm._v("More fitness data needed")])])
}
var staticRenderFns = []

export { render, staticRenderFns }